import { FaUsersCog } from "react-icons/fa";

export const switchViewItem = {
    id: '3234343',
    text: 'Switch Views',
    icon: <FaUsersCog />
}